import styles from "./common.module.scss";

export default function JewelrySizeGuide({ sizeGuideType }) {

    return (
      <>
        <div className={styles.size_guide_wrapper}>
          <div className="no-hori-scroll">
            <p className="normal italic sizeguide-hd">Find your fit</p>
            <p className="x-large light sizeguide-category">
            Olivela Necklace Sizing Guide
            </p>
            <div className="sizeguide-img"><img alt="Necklaces Size Guide" src="../images/jewelry_working-file.png" width="395" /></div>
            <p className="x-small sizeguide-txt">
            Should you need further sizing assistance at any point in your jewelry journey, our Jewelry Concierge is here for you. Reach us at <a className="underline" href="mailto: jewelryconcierge@olivela.com">jewelryconcierge@olivela.com.</a></p>

            <p className="x-small italic sizeguide-txt light">* This information is intended for use as a general guideline. Sizing and fit may vary by brand.</p>
          </div>
          
        </div>
      </>
    );

}
